module.exports = "/images/edit.dea3186c6afc88b1282d9ae745644bf0.svg";